import { useState } from 'react';
import { Aviso, Cartao } from '../../componentes/ui.jsx';
import { useAuth } from '../../lib/autenticacao.jsx';
import { Confirmacao } from './Confirmacao.jsx';
import { useSalvarConfig } from './hooks.js';

/**
 * Por onde ESTE numero conversa: QR Code (Baileys) ou API oficial da Meta.
 *
 * A troca e por conexao (W1..W5) e de um clique: o servidor desliga a conta
 * pelo metodo antigo sem apagar nada (a sessao do QR Code e as credenciais da
 * Meta ficam guardadas), entao voltar tambem e um clique. O menu automatico
 * se adapta sozinho: lista numerada no QR Code, botoes/lista na API oficial.
 */

const METODOS = [
  {
    valor: 'baileys',
    titulo: 'QR Code',
    apoio: 'WhatsApp do celular (Baileys)',
    pontos: ['Conecta lendo o QR Code', 'Menu em lista numerada', 'Lembretes e campanhas liberados']
  },
  {
    valor: 'oficial',
    titulo: 'API oficial',
    apoio: 'WhatsApp Cloud API da Meta',
    pontos: ['Conecta com as credenciais da Meta', 'Menu com botões e lista de opções', 'Só responde quem escreveu nas últimas 24h']
  }
];

export function MetodoConexao({ canal }) {
  const { podeAcessar } = useAuth();
  const podeTrocar = podeAcessar('admin');
  const salvar = useSalvarConfig(canal.chave);
  const [pedido, setPedido] = useState(null);

  const atual = canal.metodo ?? 'baileys';
  const ligado = canal.status === 'conectado' || canal.status === 'conectando' || canal.status === 'aguardando_qr';

  function escolher(valor) {
    if (valor === atual || !podeTrocar || salvar.isPending) return;
    // Com o numero no ar, trocar derruba a conexao: confirma antes.
    if (ligado) setPedido(valor);
    else salvar.mutate({ metodo: valor });
  }

  return (
    <Cartao titulo="Método de conexão">
      <div className="cx-metodos" role="radiogroup" aria-label="Método de conexão deste número">
        {METODOS.map((m) => (
          <button
            key={m.valor}
            type="button"
            role="radio"
            aria-checked={atual === m.valor}
            disabled={!podeTrocar || salvar.isPending}
            className={`cx-metodo${atual === m.valor ? ' cx-metodo--ativo' : ''}`}
            onClick={() => escolher(m.valor)}
          >
            <span className="cx-metodo__titulo">{m.titulo}</span>
            <span className="cx-metodo__apoio">{m.apoio}</span>
            <ul className="cx-metodo__pontos">
              {m.pontos.map((p) => (
                <li key={p}>{p}</li>
              ))}
            </ul>
          </button>
        ))}
      </div>

      {salvar.isError && (
        <Aviso tom="perigo" aoFechar={salvar.reset}>
          {salvar.error.message}
        </Aviso>
      )}

      {pedido && (
        <Confirmacao
          titulo={`Trocar para ${pedido === 'oficial' ? 'a API oficial' : 'o QR Code'}?`}
          rotuloConfirmar="Sim, trocar"
          carregando={salvar.isPending}
          aoCancelar={() => setPedido(null)}
          aoConfirmar={() => salvar.mutate({ metodo: pedido }, { onSuccess: () => setPedido(null) })}
        >
          <p>
            O número {canal.nome} será desconectado agora. Nada é apagado: a sessão do QR Code e as credenciais da Meta
            continuam guardadas, então voltar também é um clique.
          </p>
        </Confirmacao>
      )}
    </Cartao>
  );
}
